import "core-js/modules/es.error.cause.js";
import { recursionCopy } from '@/views/customer/roleManage/utils';
import { accountBankList, addMerchant, editMerchant, merchantDetail } from './request';
import { customerResource } from '@/views/system/customerManage/request';
export default {
  data() {
    return {
      dialogVisible: false,
      dataFrom: {
        subjectType: 'INTERMEDIARY_TRIPARTITE_PAY',
        isIntermediary: undefined,
        type: undefined,
        customerId: undefined,
        paymentMerchantId: '',
        payIdTypeArr: []
      },
      intermediaryList: [],
      accountBankList: accountBankList,
      typeList: [{
        name: '微信',
        id: 1
      }, {
        name: '支付宝',
        id: 2
      }, {
        name: '银联',
        id: 3
      }, {
        name: '易宝',
        id: 4
      }],
      plainOptions: [{
        label: '支付宝',
        value: 'ALIPAY_APPID'
      }, {
        label: '微信公众号',
        value: 'PUBLIC_APPID'
      }, {
        label: '微信小程序',
        value: 'MINI_APPID'
      }],
      continueAdd: false,
      payIdTypeArr: [],
      rule1: {
        subjectType: [{
          required: true,
          trigger: 'change',
          validator: this.validateSubjectType
        }],
        type: [{
          required: true,
          trigger: 'change',
          message: this.$t('请选择') + this.$t('账户类型')
        }]
      },
      rule2: {
        subjectType: [{
          required: true,
          trigger: 'change',
          validator: this.validateSubjectType
        }],
        type: [{
          required: true,
          trigger: 'change',
          message: this.$t('请选择') + this.$t('账户类型')
        }]
      }
    };
  },
  computed: {
    dataRule() {
      return this.rule1;
    },
    dataRule2() {
      return this.rule2;
    }
  },
  methods: {
    validateSubjectType(rule, value, callback) {
      if (!this.dataFrom.subjectType) {
        callback(new Error(this.$t('请选择') + this.$t('账户类型')));
      } else if (this.dataFrom.subjectType == 'INTERMEDIARY_TRIPARTITE_PAY' && !this.dataFrom.customerId) {
        callback(new Error(this.$t('请选择') + this.$t('账户主体')));
      } else {
        callback();
      }
    },
    validateOccupation(rule, value, callback) {
      if (value.indexOf(',') == -1) {
        callback(new Error(this.$t('格式不对,例:1至N类，输入格式为1,n;N类，输入格式为n,n')));
      } else {
        callback();
      }
    },
    validateID(rule, value, callback) {
      if (!this.payIdTypeArr || !this.payIdTypeArr.length) {
        callback(new Error(this.$t('请选择支付ID')));
      } else {
        callback();
      }
    },
    init(data) {
      customerResource({
        isAll: 1
      }).then(res => {
        this.intermediaryList = res;
      });
      if (data.paymentMerchantId) {
        merchantDetail({
          paymentMerchantId: data.paymentMerchantId
        }).then(res => {
          this.dataFrom = res;
          this.dataFrom.subjectType = res.customerId == 0 ? 'PLATFORM_PAY' : 'INTERMEDIARY_TRIPARTITE_PAY';
          this.dataFrom.payIdTypeArr = res.payIdType ? res.payIdType.split(',') : [];
          this.payIdTypeArr = res.payIdType ? res.payIdType.split(',') : [];
        });
        this.ruleFun(data.type);
      }
      this.dialogVisible = true;
    },
    handleSure() {
      this.$refs.dataFrom.validate(valid => {
        if (valid) {
          var _this$dataFrom$payIdT;
          this.dataFrom.payIdType = ((_this$dataFrom$payIdT = this.dataFrom.payIdTypeArr) === null || _this$dataFrom$payIdT === void 0 ? void 0 : _this$dataFrom$payIdT.join(',')) || '';
          this.dataFrom.customerId = this.dataFrom.customerId ? this.dataFrom.customerId : 0;
          let fun = this.dataFrom.paymentMerchantId ? editMerchant : addMerchant;
          fun(this.dataFrom).then(() => {
            this.$message.success(this.$t('操作成功'));
            if (!this.dataFrom.paymentMerchantId && this.continueAdd) {
              this.$refs.dataFrom.resetFields();
              this.$emit('ok', 'continueAdd');
              this.dataFrom.customerId = undefined;
              this.dataFrom.payIdTypeArr = [];
              this.payIdTypeArr = [];
            } else {
              this.$emit('ok');
            }
          });
        }
      });
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    },
    onChangeID() {
      this.dataFrom.payIdTypeArr = this.payIdTypeArr;
      if (!this.payIdTypeArr.includes('ALIPAY_APPID')) {
        this.dataFrom.aAppid = '';
      }
      if (!this.payIdTypeArr.includes('PUBLIC_APPID')) {
        this.dataFrom.pAppid = '';
      }
      if (!this.payIdTypeArr.includes('MINI_APPID')) {
        this.dataFrom.mAppid = '';
      }
      console.log(this.dataFrom);
    },
    onChange2(val) {
      this.dataFrom.subjectType = val;
      this.dataFrom.customerId = undefined;
    },
    onChange(value) {
      this.rule1 = recursionCopy(this.rule2);
      const obj = {
        paymentMerchantId: this.dataFrom.paymentMerchantId,
        isIntermediary: this.dataFrom.isIntermediary,
        subjectType: this.dataFrom.subjectType,
        type: this.dataFrom.type,
        customerId: this.dataFrom.customerId,
        aAppid: '',
        pAppid: '',
        mAppid: ''
      };
      this.$refs.dataFrom.resetFields();
      this.$nextTick(() => {
        this.dataFrom = obj;
        this.ruleFun(value);
      });
    },
    ruleFun(value) {
      if (value == 1) {
        this.rule1.mchid = [{
          required: true,
          trigger: 'blur',
          message: this.$t('请输入') + this.$t('商户号')
        }, {
          required: false,
          max: 100,
          message: this.$t('最多输入100字符'),
          trigger: 'change'
        }, {
          required: false,
          min: 5,
          message: this.$t('至少输入5字符'),
          trigger: 'change'
        }];
        this.rule1.key = [{
          required: true,
          trigger: 'blur',
          message: this.$t('请输入') + this.$t('API密钥')
        }];
        this.rule1.callbackAddress = [{
          required: true,
          trigger: 'blur',
          message: this.$t('请输入') + this.$t('回调地址')
        }, {
          required: false,
          max: 100,
          message: this.$t('最多输入100字符'),
          trigger: 'change'
        }, {
          required: false,
          min: 5,
          message: this.$t('至少输入5字符'),
          trigger: 'change'
        }];
        this.rule1.apiclientCert = [{
          required: true,
          trigger: 'blur',
          message: this.$t('请输入') + this.$t('apiclient_cert.pem证书')
        }];
        this.rule1.apiclientKey = [{
          required: true,
          trigger: 'blur',
          message: this.$t('请输入') + this.$t('apiclient_key.pem证书')
        }];
      } else if (value == 2) {
        this.rule1.aAppid = [{
          required: true,
          trigger: 'blur',
          message: this.$t('请输入') + this.$t('APPID')
        }];
        this.rule1.callbackAddress = [{
          required: true,
          trigger: 'blur',
          message: this.$t('请输入') + this.$t('回调地址')
        }, {
          required: false,
          max: 100,
          message: this.$t('最多输入100字符'),
          trigger: 'change'
        }, {
          required: false,
          min: 5,
          message: this.$t('至少输入5字符'),
          trigger: 'change'
        }];
        this.rule1.notifyAddresss = [{
          required: true,
          trigger: 'blur',
          message: this.$t('请输入') + this.$t('通知地址')
        }];
        this.rule1.key = [{
          required: true,
          trigger: 'blur',
          message: this.$t('请输入') + this.$t('私钥')
        }];
        this.rule1.alipayCertPublicKey = [{
          required: true,
          trigger: 'blur',
          message: this.$t('请输入') + this.$t('alipayCertPublicKey.crt证书')
        }];
        this.rule1.appCertPublicKey = [{
          required: true,
          trigger: 'blur',
          message: this.$t('请输入') + this.$t('appCertPublicKey.crt证书')
        }];
        this.rule1.alipayRootCert = [{
          required: true,
          trigger: 'blur',
          message: this.$t('请输入') + this.$t('alipayRootCert.crt证书')
        }];
      } else if (value == 3) {
        this.rule1.bankAccount = [{
          required: true,
          trigger: 'blur',
          message: this.$t('请输入') + this.$t('账号')
        }];
        this.rule1.accountBank = [{
          required: true,
          trigger: 'change',
          message: this.$t('请选择') + this.$t('开户银行')
        }];
        this.rule1.accountInfo = [{
          required: true,
          trigger: 'blur',
          message: this.$t('请输入') + this.$t('开户行信息')
        }];
      } else {
        this.rule1.mchid = [{
          required: true,
          trigger: 'blur',
          message: this.$t('请输入') + this.$t('商户号')
        }, {
          max: 100,
          message: this.$t('最多输入100字符'),
          trigger: 'blur'
        }, {
          min: 5,
          message: this.$t('至少输入5字符'),
          trigger: 'blur'
        }];
        this.rule1.upMchid = [{
          required: true,
          trigger: 'blur',
          message: this.$t('请输入') + this.$t('上级商户号')
        }, {
          max: 100,
          message: this.$t('最多输入100字符'),
          trigger: 'blur'
        }, {
          min: 5,
          message: this.$t('至少输入5字符'),
          trigger: 'blur'
        }];
        this.rule1.callbackAddress = [{
          required: true,
          trigger: 'blur',
          message: this.$t('请输入') + this.$t('回调地址')
        }, {
          max: 100,
          message: this.$t('最多输入100字符'),
          trigger: 'blur'
        }, {
          min: 5,
          message: this.$t('至少输入5字符'),
          trigger: 'blur'
        }];
        this.rule1.payIdTypeArr = [{
          required: true,
          validator: this.validateID
        }];
        this.rule1.aAppid = [{
          required: true,
          trigger: 'blur',
          message: this.$t('请输入') + this.$t('APPID')
        }];
        this.rule1.pAppid = [{
          required: true,
          trigger: 'blur',
          message: this.$t('请输入') + this.$t('公众号 APPID')
        }];
        this.rule1.mAppid = [{
          required: true,
          trigger: 'blur',
          message: this.$t('请输入') + this.$t('小程序 APPID')
        }];
      }
      console.log(this.rule1, 666);
    }
  }
};